import React from 'react'
import Signup from '../Components/SignUp/Signup'

function Sign() {
  return (
    <div>
        <Signup/>
    </div>
  )
}

export default Sign